// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { WebAppCandidateVerdictSchema } from '../inputTypeSchemas/WebAppCandidateVerdictSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK WEB APP CANDIDATE SCHEMA
/////////////////////////////////////////

export const ExternalNetworkWebAppCandidateSchema = z.object({
  verdict: WebAppCandidateVerdictSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  domainId: z.string().nullable(),
  networkServiceId: z.string().nullable(),
  clusterId: z.string().nullable(),
  originUrl: z.string(),
  apexDomain: z.string(),
  pageTitle: z.string().nullable(),
  faviconHash: z.string().nullable(),
  product: z.string().nullable(),
  similarityKey: z.string(),
  applicationId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ExternalNetworkWebAppCandidate = z.infer<typeof ExternalNetworkWebAppCandidateSchema>

export default ExternalNetworkWebAppCandidateSchema;
